import type { ReactNode } from "react";

interface ContentStatusProps {
  loading: boolean;
  error: string;
  onRetry: () => void;
  children: ReactNode;
}

export default function ContentStatus({
  loading,
  error,
  onRetry,
  children,
}: ContentStatusProps) {
  if (loading) {
    return (
      <div className="w-full flex items-center justify-center py-16">
        <i className="ri-loader-4-line animate-spin text-3xl text-primary-500" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full flex flex-col items-center justify-center py-16 text-center">
        <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3">
          <i className="ri-error-warning-line text-xl" />
        </div>
        <p className="text-sm text-foreground-600 font-body mb-4">{error}</p>
        <button
          onClick={onRetry}
          className="px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-label text-sm font-medium whitespace-nowrap rounded-md transition-colors cursor-pointer"
        >
          <i className="ri-refresh-line mr-2" />
          Thử lại
        </button>
      </div>
    );
  }

  return <>{children}</>;
}